<template>
  <div>
    <v-dialog
      width="90%"
      persistent
      scrollable
      v-model="dialogEmployeeDeviceList"
    >
      <v-card min-height="50vh">
        <v-card-title class="grey lighten-2">
          <span>พนักงานลงทะเบียนที่ Device</span>

          <v-spacer></v-spacer>

          <v-btn icon @click="handleCloseDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-title class="d-flex align-center">
          <div>
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              clearable
              dense
              outlined
              hide-details
              placeholder="รหัส - ชื่อพนักงาน"
              @input="handleSearch"
            ></v-text-field>
          </div>
          <div>
            <v-btn
              @click="getTempEmployeeList"
              class="ml-4"
              color="grey darken-3"
              outlined
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            :loading="loading"
            :headers="[
              {
                text: 'รหัสพนักงาน',
                align: 'start',
                value: 'employee_code',
                class: 'text-no-wrap',
                width: '10%',
              },
              // {
              //   text: 'ชื่อ - นามสกุล',
              //   value: 'full_name_th',
              //   class: 'text-no-wrap',
              //   width: '12%',
              // },
              {
                text: 'Name - Surname',
                value: 'full_name_en',
                class: 'text-no-wrap',
                width: '12%',
              },
              {
                text: 'Serial Card',
                align: 'start',
                value: 'card_serial_number',
                class: 'text-no-wrap',
                width: '10%',
                sortable: false,
              },
              {
                text: 'Pin Code',
                align: 'start',
                value: 'pin_code',
                class: 'text-no-wrap',
                width: '8%',
                sortable: false,
              },
              {
                text: 'อัพเดทล่าสุด',
                value: 'last_updated',
                class: 'text-no-wrap',
                width: '15%',
              },
              {
                text: 'พนักงานลงทะเบียนที่ Device',
                value: 'form_device',
                class: 'text-no-wrap',
                sortable: false,
                width: '25%',
              },
              {
                text: '',
                value: 'actions',
                class: 'text-no-wrap',
                sortable: false,
                width: '11%',
              },
            ]"
            :items="tempEmployeeList"
            :options.sync="options"
            :server-items-length="totalTempEmployeeList"
            :items-per-page="10"
            class="elevation-1"
            :footer-props="{
              itemsPerPageOptions: [10, 25, 50, 100],
              itemsPerPageText: 'Rows per page:',
            }"
          >
            <!-- <template v-slot:item.full_name_th="{ item }">
              <div>
                {{ item.firstname_th || '' }} {{ item.lastname_th || '' }}
              </div>
            </template> -->
            <template v-slot:item.full_name_en="{ item }">
              <div>
                {{ item.firstname_en || '' }} {{ item.lastname_en || '' }}
              </div>
            </template>
            <template v-slot:item.pin_code="{ item }">
              <div>
                {{ item.pin_code ? '****' : '' }}
              </div>
            </template>
            <template v-slot:item.last_updated="{ item }">
              <span v-if="item.last_updated">
                {{ item.last_updated | datetimeFormat }}
              </span>
              <span v-else>-</span>
            </template>
            <template v-slot:item.form_device="{ item }">
              <span v-if="item.hardwares && item.hardwares.length > 0">
                <v-chip
                  label
                  outlined
                  small
                  class="mr-2 my-1"
                  v-for="item in item.hardwares.slice(0, 2)"
                  :key="item.hardware_uuid"
                >
                  {{ item.hardware_code }}
                </v-chip>
                <v-chip label outlined small v-if="item.hardwares.length > 2"
                  >+ {{ item.hardwares.length - 2 }}</v-chip
                >
              </span>
              <span v-else>-</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="text-no-wrap">
                <v-btn
                  :disabled="
                    uiCtrl &&
                    !uiCtrl.isEnable('btn:::employee_temporary:delete')
                  "
                  @click="handleDeleteEmployeeDevice(item)"
                  color="error darken-1"
                  icon
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-btn
                  @click="handleAddEmployeeDevice(item)"
                  class="ml-2"
                  color="primary"
                  outlined
                  small
                >
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogEmployeeDeviceForm"
      scrollable
      persistent
      max-width="800px"
    >
      <v-card>
        <v-card-title class="pb-0">
          <span class="text-h5">เพิ่มพนักงาน</span>
        </v-card-title>
        <v-card-text style="height: 80dvh">
          <v-form ref="form" lazy-validation style="height: calc(100% - 50px)">
            <v-container class="mt-4 pa-0" style="height: 100%">
              <v-tabs v-model="tabs">
                <v-tab>
                  ข้อมูลทั่วไป
                  <span class="red--text ml-1"><strong>*</strong></span>
                </v-tab>
                <v-tab class="text-capitalize">การระบุตัวตน</v-tab>
                <v-tab class="text-capitalize">TA & Access</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tabs" style="height: 100%">
                <v-tab-item
                  class="px-4 py-4"
                  style="height: 100%; overflow-y: auto"
                >
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <div class="d-flex">
                        <div class="mr-4">
                          <v-list-item-avatar
                            rounded
                            size="64"
                            class="mx-0 my-0"
                          >
                            <v-img
                              v-if="uploadFilePreview"
                              style="width: 64px"
                              :src="
                                'data:image/jpeg;base64,' + uploadFilePreview
                              "
                              aspect-ratio="1"
                            ></v-img>
                            <v-img
                              v-else-if="employee.url_photo_identifier"
                              style="width: 64px"
                              :src="employee.url_photo_identifier"
                              aspect-ratio="1"
                            ></v-img>
                            <v-avatar
                              v-else
                              tile
                              color="grey lighten-4"
                              size="64"
                            >
                              <v-icon color="grey lighten-1" large
                                >mdi-account</v-icon
                              >
                            </v-avatar>
                          </v-list-item-avatar>
                        </div>
                        <div class="flex-grow-1">
                          <v-file-input
                            :rules="[
                              (value) =>
                                !value ||
                                value.size < 2000000 ||
                                'Image size should be less than 2 MB!',
                            ]"
                            class="fix-google-chrome"
                            v-model="fileImage"
                            ref="imgFileInput"
                            accept="image/jpeg"
                            show-size
                            @change="onFileChange"
                            @click:clear="onFileClear"
                            outlined
                            dense
                            hide-details
                          >
                          </v-file-input>
                          <div class="mt-1 ml-8 caption">
                            <span>jpeg เท่านั้น, </span>
                            <span>ขนาดไฟล์ไม่เกิน 2Mb</span>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-switch
                        v-model="employee.is_active"
                        :label="employee.is_active ? 'Active' : 'Not Active'"
                      >
                        <template v-slot:label>
                          <span
                            class="body-2 ml-2 grey--text text--darken-3 font-weight-medium"
                          >
                            {{ employee.is_active ? 'Active' : 'Not Active' }}
                          </span>
                        </template>
                      </v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <label class="body-2">
                        รหัสอ้างอิงพนักงาน
                        <span
                          v-if="company.is_employee_reference_code"
                          class="red--text"
                        >
                          <strong>*</strong>
                        </span>
                      </label>
                      <v-text-field
                        class="fix-google-chrome mt-1"
                        v-model="employee.employee_reference_code"
                        :rules="
                          company.is_employee_reference_code
                            ? [
                                (v) => !!v || 'โปรดระบุรหัสอ้างอิงพนักงาน',
                                (v) =>
                                  (v && v.length >= 1 && v.length <= 32) ||
                                  'รหัสพนักงานต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
                              ]
                            : []
                        "
                        required
                        clearable
                        @change="checkEmpty($event, 'employee_reference_code')"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <label class="body-2">
                        รหัสพนักงาน
                        <span class="red--text"><strong>*</strong></span>
                      </label>
                      <v-text-field
                        class="fix-google-chrome mt-1"
                        v-model="employee.employee_code"
                        :rules="[
                          (v) => !!v || 'โปรดระบุรหัสพนักงาน',
                          (v) =>
                            (v && v.length >= 1 && v.length <= 32) ||
                            'รหัสพนักงานต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
                        ]"
                        required
                        @change="checkEmpty($event, 'employee_code')"
                        outlined
                        dense
                        readonly
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <label class="body-2">คำนำหน้าชื่อ</label>
                      <v-autocomplete
                        class="fix-google-chrome mt-1"
                        v-model="employee.company_prefix_uuid"
                        :items="prefixs"
                        item-text="title_th"
                        item-value="company_prefix_uuid"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <label class="body-2">
                        ชื่อ
                        <span class="red--text"><strong>*</strong></span>
                      </label>
                      <v-text-field
                        class="fix-google-chrome mt-1"
                        v-model="employee.firstname_th"
                        :rules="[
                          (v) => !!v || 'โปรดระบุชื่อ',
                          (v) =>
                            !v ||
                            (v && v.length <= 45) ||
                            'ชื่อต้องน้อยกว่า 45 ตัวอักษร',
                        ]"
                        required
                        clearable
                        @change="checkEmpty($event, 'firstname_th')"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <label class="body-2">
                        นามสกุล
                        <span class="red--text"><strong>*</strong></span>
                      </label>
                      <v-text-field
                        class="fix-google-chrome mt-1"
                        v-model="employee.lastname_th"
                        :rules="[
                          (v) => !!v || 'โปรดระบุนามสกุล',
                          (v) =>
                            !v ||
                            (v && v.length <= 80) ||
                            'นามสกุลต้องน้อยกว่า 80 ตัวอักษร',
                        ]"
                        required
                        clearable
                        @change="checkEmpty($event, 'lastname_th')"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"
                      ><label class="body-2">ชื่อ (อังกฤษ)</label>
                      <v-text-field
                        class="fix-google-chrome mt-1"
                        v-model="employee.firstname_en"
                        :rules="[
                          (v) =>
                            !v ||
                            (v && v.length <= 45) ||
                            'ชื่อต้องน้อยกว่า 45 ตัวอักษร',
                        ]"
                        clearable
                        @change="checkEmpty($event, 'firstname_en')"
                        outlined
                        dense
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" sm="6" md="6">
                      <label class="body-2">นามสกุล (อังกฤษ)</label>
                      <v-text-field
                        class="fix-google-chrome mt-1"
                        v-model="employee.lastname_en"
                        :rules="[
                          (v) =>
                            !v ||
                            (v && v.length <= 80) ||
                            'นามสกุลต้องน้อยกว่า 80 ตัวอักษร',
                        ]"
                        clearable
                        @change="checkEmpty($event, 'lastname_en')"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <label class="body-2">เพศ</label>
                      <v-autocomplete
                        class="fix-google-chrome mt-1"
                        v-model="employee.gender_id"
                        :items="genders"
                        item-text="title_th"
                        item-value="gender_id"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <label class="body-2">เบอร์โทรศัพท์มือถือ</label>
                      <v-text-field
                        class="fix-google-chrome mt-1"
                        v-model="employee.phone_no"
                        clearable
                        :rules="[
                          (v) =>
                            !v ||
                            /^\d+$/.test(v) ||
                            'เบอร์โทรศัพท์มือถือต้องเป็นตัวเลขเท่านั้น',
                          (v) =>
                            !v ||
                            v.charAt(0) === '0' ||
                            'เบอร์โทรศัพท์มือถือต้องขึ้นต้นด้วย 0',
                          (v) =>
                            !v ||
                            (v && v.length === 10) ||
                            'เบอร์โทรศัพท์มือถือต้องเท่ากับ 10',
                        ]"
                        @change="checkEmpty($event, 'phone_no')"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <label class="body-2">อีเมล</label>
                      <v-text-field
                        class="fix-google-chrome mt-1"
                        v-model="employee.email"
                        clearable
                        :rules="[
                          (v) => !v || /.+@.+\..+/.test(v) || 'อีเมลไม่ถูกต้อง',
                        ]"
                        @change="checkEmpty($event, 'email')"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" v-if="company.is_ms_entraid">
                      <label class="body-2">Microsoft Entra ID (email)</label>
                      <v-text-field
                        class="fix-google-chrome mt-1"
                        v-model="employee.ms_entraid_email"
                        clearable
                        :rules="[
                          (v) => !v || /.+@.+\..+/.test(v) || 'อีเมลไม่ถูกต้อง',
                        ]"
                        @change="checkEmpty($event, 'ms_entraid_email')"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <label class="body-2">วันเกิด</label>
                      <date-picker
                        v-model="employee.birthday"
                        class="mt-1"
                        type="date"
                        format="DD/MM/YYYY"
                        style="width: 100%"
                      ></date-picker>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <label class="body-2">
                        หน่วยงาน
                        <span class="red--text"><strong>*</strong></span>
                      </label>
                      <v-autocomplete
                        class="fix-google-chrome mt-1"
                        v-model="employee.organization_uuid"
                        :items="
                          organizations.map((org) => ({
                            ...org,
                            text: `${org.organization_code} - ${org.title_th}`,
                          }))
                        "
                        :rules="[(v) => !!v || 'โปรดระบุหน่วยงาน']"
                        item-text="text"
                        item-value="organization_uuid"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <label class="body-2">
                        ตำแหน่ง
                        <span class="red--text"><strong>*</strong></span>
                      </label>
                      <v-autocomplete
                        class="fix-google-chrome mt-1"
                        v-model="employee.position_uuid"
                        :items="
                          positions.map((pos) => ({
                            ...pos,
                            text: `${pos.position_code} - ${pos.title_th}`,
                          }))
                        "
                        :rules="[(v) => !!v || 'โปรดระบุตำแหน่ง']"
                        item-text="text"
                        item-value="position_uuid"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <label class="body-2">
                        ประเภทพนักงาน
                        <span class="red--text"><strong>*</strong></span>
                      </label>
                      <v-autocomplete
                        class="fix-google-chrome mt-1"
                        v-model="employee.employee_type_uuid"
                        :items="
                          employeeTypes.map((empType) => ({
                            ...empType,
                            text: `${empType.employee_type_code} - ${empType.title_th}`,
                          }))
                        "
                        :rules="[(v) => !!v || 'โปรดระบุประเภทพนักงาน']"
                        item-text="text"
                        item-value="employee_type_uuid"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <label class="body-2">
                        กะทำงาน
                        <span class="red--text"><strong>*</strong></span>
                      </label>
                      <v-autocomplete
                        class="fix-google-chrome mt-1"
                        v-model="employee.shift_uuid"
                        :items="
                          shifts.map((sh) => ({
                            ...sh,
                            text: `${sh.shift_code} - ${sh.title_th}`,
                          }))
                        "
                        :rules="[(v) => !!v || 'โปรดระบุกะทำงาน']"
                        item-text="text"
                        item-value="shift_uuid"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <label class="body-2">ระดับพนักงาน</label>
                      <v-autocomplete
                        class="fix-google-chrome mt-1"
                        v-model="employee.employee_level_uuid"
                        :items="
                          employeeLevels
                            .map((item) => ({
                              ...item,
                              text: `${item.employee_level_code} - ${item.title_th}`,
                            }))
                            .sort((a, b) =>
                              a.employee_level_code.localeCompare(
                                b.employee_level_code
                              )
                            )
                        "
                        item-text="text"
                        item-value="employee_level_uuid"
                        outlined
                        dense
                        autocomplete="new-password"
                        name="ignore-autofill-employee-level"
                        id="ignore-autofill-employee-level"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item
                  class="px-4 py-4"
                  style="height: 100%; overflow-y: auto"
                >
                  <div>
                    <label class="body-2">Serial Card</label>
                    <v-text-field
                      v-model="employee.card.sn"
                      :rules="[
                        (v) =>
                          !v ||
                          /^[0-9A-Za-z]+$/.test(v) ||
                          'ใส่ได้เฉพาะตัวเลขและตัวอักษร',
                        (v) =>
                          !v ||
                          (v && v.length <= 32) ||
                          'หมายเลขบัตรต้องน้อยกว่าหรือเท่ากับ 32 ตัวอักษร',
                      ]"
                      class="fix-google-chrome mt-1"
                      clearable
                      outlined
                      dense
                      :error="!serialValid"
                      :error-messages="serialMessageError"
                      ref="serialInput"
                      @input="handleSerialChange"
                    >
                    </v-text-field>
                  </div>
                  <div>
                    <label class="body-2">Pin Code</label>
                    <v-text-field
                      class="fix-google-chrome mt-1"
                      v-model="employee.pin_code"
                      :rules="[
                        (v) =>
                          !v || /^\d+$/.test(v) || 'ต้องเป็นตัวเลขเท่านั้น',
                        (v) =>
                          !v ||
                          /^\d{4}$/.test(v) ||
                          'Pin Code ต้องเท่ากับ 4 ตัวอักษร',
                      ]"
                      clearable
                      outlined
                      dense
                      autocomplete="new-password"
                      name="ignore-autofill-pin-code"
                      id="ignore-autofill-pin-code"
                      :type="showPassword ? 'text' : 'password'"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                    ></v-text-field>
                  </div>
                  <div>
                    <label class="body-2">รูปแบบการระบุตัวตน</label>
                    <v-autocomplete
                      v-model="employee.identify_mode"
                      class="fix-google-chrome mt-1"
                      :items="identifyModes"
                      item-text="title_th"
                      item-value="identify_mode"
                      outlined
                      dense
                      :disabled="
                        uiCtrl &&
                        !uiCtrl.isEnable(
                          'select:::identify-mode:hardware:model:update'
                        )
                      "
                    >
                    </v-autocomplete>
                  </div>

                  <v-card
                    v-for="biometric in biometrics"
                    :key="biometric.biometric_code"
                    style="cursor: pointer"
                    class="mt-1 pa-2 d-flex justify-space-between"
                    outlined
                    @click="handleOnClickBiometric(biometric)"
                  >
                    <div class="d-flex">
                      <v-avatar size="40">
                        <img
                          class="biometric-icon"
                          :src="biometric.icon_image_url"
                          alt="image"
                        />
                      </v-avatar>
                      <div class="ml-2">
                        <div>
                          {{ biometric.title_th }}
                        </div>
                        <div style="font-size: 12px">
                          <span
                            :class="
                              biometric.min &&
                              (employeeBiometric.find(
                                (e) =>
                                  e.biometric_code === biometric.biometric_code
                              )?.biometric_property?.length || 0) >=
                                biometric.min
                                ? 'grey--text'
                                : 'red--text'
                            "
                            >{{
                              employeeBiometric.find(
                                (e) =>
                                  e.biometric_code === biometric.biometric_code
                              )?.biometric_property?.length || 0
                            }}
                            / {{ biometric.biometric_property.length }}</span
                          >
                          <span> {{ biometric.title_th }}</span>
                        </div>
                      </div>
                    </div>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  class="px-6 py-4"
                  style="height: 100%; overflow-y: auto"
                >
                  <div>
                    <!-- <p class="mb-2">ข้อมูล Time Attendance</p> -->
                    <div class="mb-6">
                      <label class="body-2 mb-1">วันเวลาเริ่มใช้งาน</label>
                      <date-picker
                        v-model="employee.time_attendance_start_time"
                        type="datetime"
                        format="DD/MM/YYYY HH:mm"
                        style="width: 100%"
                      ></date-picker>
                    </div>
                    <div class="mb-6">
                      <label class="body-2 mb-1">วันเวลาสิ้นสุดใช้งาน</label>
                      <date-picker
                        v-model="employee.time_attendance_end_time"
                        type="datetime"
                        format="DD/MM/YYYY HH:mm"
                        style="width: 100%"
                      ></date-picker>
                    </div>
                    <div>
                      <label class="body-2 mr-4">
                        กลุ่มสิทธิ์ (TA & Access)
                      </label>
                      <v-autocomplete
                        v-model="accessAuthoritiesSelected"
                        class="fix-google-chrome mt-1"
                        :loading="accessAuthorityLoading"
                        :items="
                          accessAuthorities.map((item) => ({
                            ...item,
                            title_th: `${item.authority_code} - ${item.title_th}`,
                          }))
                        "
                        :disabled="
                          uiCtrl &&
                          !uiCtrl.isEnable('select:::employee_to_authority:get')
                        "
                        item-text="title_th"
                        item-value="authority_uuid"
                        outlined
                        dense
                        chips
                        small-chips
                        multiple
                      >
                      </v-autocomplete>
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="onCancel">ยกเลิก</v-btn>
          <v-btn color="blue darken-1" dark depressed @click="onSubmit">
            เพิ่มพนักงาน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDelete" persistent width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          ยืนยันการลบพนักงานที่ Device
        </v-card-title>

        <v-card-text class="py-2">
          <div>
            <p style="font-size: 16px">
              คุณต้องการลบพนักงาน
              <span class="error--text">{{
                confirmDeleteData.employee_code
              }}</span>
            </p>
          </div>
          <div v-if="confirmDeleteData.hardwares">
            <v-chip
              label
              outlined
              small
              class="mr-2 my-1"
              v-for="item in confirmDeleteData.hardwares"
              :key="item.hardware_uuid"
            >
              {{ item.hardware_code }}
            </v-chip>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="submitConfirmDelete">ตกลง</v-btn>
          <v-btn text @click="cancelConfirmDelete">ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogFingerFormList" persistent max-width="480">
      <v-card>
        <v-card-title class="text-h5 d-flex justify-space-between align-center">
          <span>
            {{ biometric.title_th || 'ลายนิ้วมือ' }}
          </span>
          <v-btn icon @click="dialogFingerFormList = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            v-for="item in employeeBiometric.filter(
              (e) => e.biometric_code === biometric.biometric_code
            )"
            :key="item.biometric_code"
          >
            <v-card
              v-for="bio in item.biometric_property"
              :key="bio.biometric_property_code"
              style="cursor: pointer"
              class="mt-3 pa-2 d-flex justify-space-between"
              outlined
              @click="handleClickEditFinger(bio)"
            >
              <div class="d-flex align-center">
                <v-list-item-avatar size="56" class="ma-0 pa-0">
                  <v-icon x-large>mdi-fingerprint</v-icon>
                </v-list-item-avatar>
                <div class="ml-2">
                  <div>{{ bio.title_th }}</div>
                  <div>
                    <span
                      v-if="bio.employee_biometric"
                      style="font-size: 12px"
                      class="gray--text"
                    >
                      อัพเดตเมื่อ
                      {{ bio.employee_biometric.last_updated | datetimeFormat }}
                    </span>
                  </div>
                </div>
              </div>
              <v-icon>mdi-chevron-right</v-icon>
            </v-card>
          </div>
          <div
            class="mt-5"
            v-if="
              (employeeBiometric.find(
                (e) => e.biometric_code === biometric.biometric_code
              )?.biometric_property?.length || 0) <
              (biometric.biometric_property &&
                biometric.biometric_property.length)
            "
          >
            <v-btn
              :disabled="
                uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
              "
              @click="dialogFingerFormAdd = true"
              class="primary"
              depressed
            >
              <v-icon left>mdi-plus</v-icon>
              เพิ่ม
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogFaceFormList" persistent max-width="480">
      <v-card>
        <v-card-title class="text-h5 d-flex justify-space-between align-center">
          <span>
            {{ biometric.title_th || 'ใบหน้า' }}
          </span>
          <v-btn icon @click="dialogFaceFormList = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            v-for="item in employeeBiometric.filter(
              (e) => e.biometric_code === biometric.biometric_code
            )"
            :key="item.biometric_code"
          >
            <v-card
              v-for="bio in item.biometric_property"
              :key="bio.biometric_property_code"
              style="cursor: pointer"
              class="mt-3 pa-2 d-flex justify-space-between"
              outlined
              @click="handleClickEditFace(bio)"
            >
              <div class="d-flex align-center">
                <v-list-item-avatar
                  v-if="bio?.employee_biometric?.file_base64"
                  rounded
                  size="56"
                  class="ma-0 pa-0"
                >
                  <v-img
                    :src="
                      'data:image/jpeg;base64,' +
                      bio?.employee_biometric?.file_base64
                    "
                  />
                </v-list-item-avatar>
                <v-list-item-avatar
                  v-if="bio?.employee_biometric?.file_path"
                  rounded
                  size="56"
                  class="ma-0 pa-0"
                >
                  <v-img :src="bio?.employee_biometric?.file_path" />
                </v-list-item-avatar>
                <div class="ml-2">
                  <div>{{ bio.title_th }}</div>
                  <div>
                    <span
                      v-if="bio.employee_biometric"
                      style="font-size: 12px"
                      class="gray--text"
                    >
                      อัพเดตเมื่อ
                      {{ bio.employee_biometric.last_updated | datetimeFormat }}
                    </span>
                  </div>
                </div>
              </div>
              <v-icon>mdi-chevron-right</v-icon>
            </v-card>
          </div>
          <div
            class="mt-5"
            v-if="
              (employeeBiometric.find(
                (e) => e.biometric_code === biometric.biometric_code
              )?.biometric_property?.length || 0) <
              (biometric.biometric_property &&
                biometric.biometric_property.length)
            "
          >
            <v-btn
              :disabled="
                uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
              "
              @click="dialogFaceFormAdd = true"
              class="primary"
              depressed
            >
              <v-icon left>mdi-plus</v-icon>
              เพิ่ม
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogFaceFormAdd" persistent max-width="480px">
      <v-card>
        <v-card-title class="text-h5 d-flex justify-space-between align-center">
          <span>
            {{ biometric.title_th || 'ใบหน้า' }}
          </span>
          <v-btn icon @click="onCloseDialogFaceFormAdd">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="px-4 mb-6" style="min-height: 480px">
          <div>
            <label class="body-2">
              รูปภาพ
              <span class="red--text"><strong>*</strong></span>
            </label>
            <div style="position: relative">
              <v-file-input
                class="fix-google-chrome mt-1"
                v-model="faceFileAdd"
                :rules="[
                  (v) => !!v || 'จำเป็นต้อง upload รูปภาพ',
                  (v) =>
                    !v || v.type === 'image/jpeg' || 'รูปภาพต้อง jpeg เท่านั้น',
                  (v) =>
                    !v || v.size < 500000 || 'รูปภาพต้องมีขนาดไม่เกิน 512 KB',
                ]"
                ref="imgFaceFileAddInput"
                accept="image/jpeg"
                show-size
                @change="onFaceFileAddChange"
                @click:clear="onFaceFileAddClear"
                outlined
                dense
                :disabled="
                  uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
                "
              >
              </v-file-input>
              <span
                style="
                  font-size: 13px;
                  color: #555;
                  position: absolute;
                  top: 45px;
                  right: 5px;
                "
              >
                jpeg เท่านั้น / ขนาดไฟล์ไม่เกิน 512kB
              </span>
            </div>
            <v-img
              v-if="faceFileAddPreview"
              :src="'data:image/jpeg;base64,' + faceFileAddPreview"
              width="100%"
            ></v-img>
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="onCancelDialogFaceFormAdd">ยกเลิก</v-btn>
          <v-btn
            color="blue darken-1"
            dark
            depressed
            class="ml-2"
            @click="handleEmployeeFaceFormAdd"
            >ตกลง</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogFaceFormEdit" persistent max-width="480px">
      <v-card>
        <v-card-title class="text-h5 d-flex justify-space-between align-center">
          <span>
            {{ biometric.title_th || 'ใบหน้า' }}
          </span>
          <v-btn icon @click="onCloseDialogFaceFormEdit">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="px-4 mb-6" style="min-height: 640px">
          <v-card class="mt-3 pa-2 d-flex justify-space-between" outlined>
            <div class="d-flex align-center">
              <v-list-item-avatar
                v-if="biometricSelected?.employee_biometric?.file_base64"
                rounded
                size="56"
                class="ma-0 pa-0"
              >
                <v-img
                  :src="
                    'data:image/jpeg;base64,' +
                    biometricSelected?.employee_biometric?.file_base64
                  "
                />
              </v-list-item-avatar>
              <v-list-item-avatar
                v-if="biometricSelected?.employee_biometric?.file_path"
                rounded
                size="56"
                class="ma-0 pa-0"
              >
                <v-img
                  :src="biometricSelected?.employee_biometric?.file_path"
                />
              </v-list-item-avatar>
              <div class="ml-2">
                <div>
                  {{ biometricSelected.title_th }}
                </div>
                <div>
                  <span style="font-size: 12px" class="gray--text"
                    >อัพเดตเมื่อ
                    {{
                      biometricSelected?.employee_biometric?.last_updated
                        | dateFormat
                    }}</span
                  >
                </div>
              </div>
            </div>
          </v-card>
          <div class="mt-5">
            <label class="body-2">
              รูปภาพ
              <span class="red--text"><strong>*</strong></span>
            </label>
            <div style="position: relative">
              <v-file-input
                class="fix-google-chrome mt-1"
                v-model="faceFileEdit"
                :rules="[
                  (v) => !!v || 'จำเป็นต้อง upload รูปภาพ',
                  (v) =>
                    !v || v.type === 'image/jpeg' || 'รูปภาพต้อง jpeg เท่านั้น',
                  (v) =>
                    !v || v.size < 500000 || 'รูปภาพต้องมีขนาดไม่เกิน 512 KB!',
                ]"
                ref="imgFaceFileEditInput"
                accept="image/jpeg"
                show-size
                @change="onFaceFileEditChange"
                @click:clear="onFaceFileEditClear"
                outlined
                dense
                :disabled="
                  uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
                "
              >
              </v-file-input>
              <span
                style="
                  font-size: 13px;
                  color: #555;
                  position: absolute;
                  top: 45px;
                  right: 5px;
                "
              >
                jpeg เท่านั้น / ขนาดไฟล์ไม่เกิน 512kB
              </span>
            </div>
          </div>
          <v-img
            v-if="faceFileEditPreview"
            :src="'data:image/jpeg;base64,' + faceFileEditPreview"
            width="100%"
          ></v-img>
          <div v-else>
            <v-img
              v-if="biometricSelected?.employee_biometric?.file_base64"
              :src="
                'data:image/jpeg;base64,' +
                biometricSelected?.employee_biometric?.file_base64
              "
              width="100%"
            ></v-img>
            <v-img
              v-if="biometricSelected?.employee_biometric?.file_path"
              :src="biometricSelected?.employee_biometric?.file_path"
              width="100%"
            ></v-img>
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <div v-if="!isDialogFaceFormEditDataChange">
            <v-btn
              :disabled="
                uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
              "
              icon
              @click="handleDeleteEmployeeFace"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-btn depressed @click="onCancelDialogFaceFormEdit">ยกเลิก</v-btn>
            <v-btn
              color="blue darken-1"
              dark
              depressed
              class="ml-2"
              @click="handleEmployeeFaceFormEdit"
              >ตกลง</v-btn
            >
          </div> -->
          <div>
            <v-btn depressed @click="onCancelDialogFaceFormEdit">ยกเลิก</v-btn>
            <v-btn
              color="blue darken-1"
              dark
              depressed
              class="ml-2"
              @click="handleEmployeeFaceFormEdit"
              >ตกลง</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogFingerFormAdd" persistent max-width="480px">
      <v-card>
        <v-card-title class="text-h5 d-flex justify-space-between align-center">
          <span>
            {{ biometric.title_th || 'ลายนิ้วมือ' }}
          </span>
          <v-btn icon @click="onCloseDialogFingerFormAdd">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="px-4">
          <div>
            <label class="body-2">
              ประเภทไฟล์ลายนิ้วมือ
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-select
              v-model="selectFileType"
              class="fix-google-chrome mt-1"
              :items="[
                { text: '.TPL', value: '.tpl' },
                { text: '.DAT', value: '.dat' },
              ]"
              :rules="[(v) => !!v || 'โปรดระบุประเภทไฟล์']"
              item-text="text"
              item-value="value"
              outlined
              dense
            ></v-select>
          </div>

          <div v-if="selectFileType === '.tpl'">
            <label class="body-2">
              {{ biometric.title_th || 'ลายนิ้วมือ' }}
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-autocomplete
              v-model="selectBiometricPropertyCode"
              class="fix-google-chrome mt-1"
              :rules="[(v) => !!v || 'โปรดระบุลายนิ้วมือ']"
              :items="filterBiometricProperty"
              item-text="title_th"
              item-value="biometric_property_code"
              outlined
              dense
              :disabled="
                uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
              "
            >
            </v-autocomplete>

            <label class="body-2">
              ลายนิ้วมือ Template
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-file-input
              class="fix-google-chrome mt-1"
              v-model="fileTpl"
              ref="fingerFileInputTpl"
              :rules="rulesTpl"
              accept=".tpl"
              show-size
              @change="onFileChangeTpl"
              @click:clear="onFileClearTpl"
              outlined
              dense
              placeholder="เลือกไฟล์ .TPL"
              :disabled="
                uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
              "
            >
            </v-file-input>
          </div>

          <div v-else>
            <label class="body-2">
              ลายนิ้วมือ Template
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-file-input
              class="fix-google-chrome mt-1"
              v-model="fileDat"
              ref="fingerFileInputDat"
              :rules="rulesDat"
              accept=".dat"
              show-size
              @change="onFileChangeDat"
              @click:clear="onFileClearDat"
              outlined
              dense
              placeholder="เลือกไฟล์ .DAT"
              :disabled="
                uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
              "
            >
            </v-file-input>
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="onCancelDialogFingerFormAdd">ยกเลิก</v-btn>
          <v-btn
            color="blue darken-1"
            dark
            depressed
            class="ml-2"
            @click="handleEmployeeFingerFormAdd"
            >ตกลง</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogFingerFormEdit" persistent max-width="480px">
      <v-card>
        <v-card-title class="text-h5 d-flex justify-space-between align-center">
          <span>
            {{ biometric.title_th || 'ลายนิ้วมือ' }}
          </span>
          <v-btn icon @click="onCloseDialogFingerFormEdit">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="px-4">
          <v-card class="mt-3 pa-2 d-flex justify-space-between" outlined>
            <div class="d-flex align-center">
              <v-list-item-avatar size="56" class="ma-0 pa-0">
                <v-icon x-large>mdi-fingerprint</v-icon>
              </v-list-item-avatar>
              <div class="ml-2">
                <div>
                  {{ biometricSelected.title_th }}
                </div>
                <div>
                  <span style="font-size: 12px" class="gray--text"
                    >อัพเดตเมื่อ
                    {{
                      biometricSelected?.employee_biometric?.last_updated
                        | dateFormat
                    }}</span
                  >
                </div>
              </div>
            </div>
          </v-card>
          <div class="mt-5">
            <div>
              <label class="body-2">
                ประเภทไฟล์ลายนิ้วมือ
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-select
                v-model="selectFileType"
                class="fix-google-chrome mt-1"
                :items="[
                  { text: '.TPL', value: '.tpl' },
                  { text: '.DAT', value: '.dat' },
                ]"
                :rules="[(v) => !!v || 'โปรดระบุประเภทไฟล์']"
                item-text="text"
                item-value="value"
                outlined
                dense
              ></v-select>
            </div>

            <div v-if="selectFileType === '.tpl'">
              <label class="body-2">
                ลายนิ้วมือ Template
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-file-input
                class="fix-google-chrome mt-1"
                v-model="fileTpl"
                ref="fingerFileInputTpl"
                :rules="rulesTpl"
                accept=".tpl"
                show-size
                @change="onFileChangeTpl"
                @click:clear="onFileClearTpl"
                outlined
                dense
                placeholder="เลือกไฟล์ .TPL"
                :disabled="
                  uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
                "
              >
              </v-file-input>
            </div>

            <div v-else>
              <label class="body-2">
                ลายนิ้วมือ Template
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-file-input
                class="fix-google-chrome mt-1"
                v-model="fileDat"
                ref="fingerFileInputDat"
                :rules="rulesDat"
                accept=".dat"
                show-size
                @change="onFileChangeDat"
                @click:clear="onFileClearDat"
                outlined
                dense
                placeholder="เลือกไฟล์ .DAT"
                :disabled="
                  uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
                "
              >
              </v-file-input>
            </div>
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <div v-if="!isDialogFingerFormEditDataChange">
            <v-btn
              :disabled="
                uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
              "
              icon
              @click="handleDeleteEmployeeFinger"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-btn depressed @click="onCancelDialogFingerFormEdit">
              ยกเลิก
            </v-btn>
            <v-btn
              color="blue darken-1"
              dark
              depressed
              class="ml-2"
              @click="handleEmployeeFingerFormEdit"
              >ตกลง</v-btn
            >
          </div> -->
          <div>
            <v-btn depressed @click="onCancelDialogFingerFormEdit">
              ยกเลิก
            </v-btn>
            <v-btn
              color="blue darken-1"
              dark
              depressed
              class="ml-2"
              @click="handleEmployeeFingerFormEdit"
              >ตกลง</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      :dialog="confirmDialogFaceDataChange"
      :loading="confirmDialogFaceDataChangeLoading"
      :dialogData="confirmDialogFaceDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogFaceDataChange"
      @submitConfirmDialog="submitConfirmDialogFaceDataChange"
    />
    <ConfirmDialog
      :dialog="confirmDialogFingerDataChange"
      :loading="confirmDialogFingerDataChangeLoading"
      :dialogData="confirmDialogFingerDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogFingerDataChange"
      @submitConfirmDialog="submitConfirmDialogFingerDataChange"
    />
    <ConfirmDialog
      :dialog="confirmDialogFaceDelete"
      :loading="confirmDialogFaceDeleteLoading"
      :dialogData="confirmDialogFaceDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogFaceDelete"
      @submitConfirmDialog="submitConfirmDialogFaceDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogFingerDelete"
      :loading="confirmDialogFingerDeleteLoading"
      :dialogData="confirmDialogFingerDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogFingerDelete"
      @submitConfirmDialog="submitConfirmDialogFingerDelete"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'DialogEmployeeDeviceList',
  components: {
    ConfirmDialog,
    DatePicker,
  },
  props: {
    dialogEmployeeDeviceList: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    biometricSelected(value) {
      const fileType = value?.employee_biometric?.file_ext.toLowerCase()
      this.selectFileType = fileType
      this.selectFileTypeInit = fileType
    },
    options: {
      handler() {
        this.getTempEmployeeList()
      },
      deep: true,
    },
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format('DD/MM/YYYY')
    },
    datetimeFormat: function (value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss')
    },
  },
  data() {
    return {
      dialogFaceFormAdd: false,
      dialogFaceFormEdit: false,
      dialogFingerFormAdd: false,
      dialogFingerFormEdit: false,
      biometricSelected: {},
      selectFileType: '.dat',
      selectFileTypeInit: '.dat',
      fileTpl: null,
      fileDat: null,
      selectBiometricPropertyCode: '',
      rulesTpl: [
        (v) => !!v || 'จำเป็นต้องเลือกไฟล์',
        (v) =>
          !v ||
          v.name.split('.').pop().toLowerCase() === 'tpl' ||
          'ไฟล์ต้องเป็น .tpl เท่านั้น',
      ],
      rulesDat: [
        (v) => !!v || 'จำเป็นต้องเลือกไฟล์',
        (v) =>
          !v ||
          v.name.split('.').pop().toLowerCase() === 'dat' ||
          'ไฟล์ต้องเป็น .dat เท่านั้น',
      ],

      dialogFaceFormList: false,
      dialogFingerFormList: false,
      biometric: {},

      tabs: null,

      serialValid: true,
      serialMessageError: '',

      showPassword: false,

      fileImage: null,
      uploadFilePreview: null,

      dialogEmployeeDeviceForm: false,
      employee: {
        biometric: [],
        card: {},
      },
      confirmDelete: false,
      confirmDeleteLoading: false,
      confirmDeleteData: {},

      cancelSource: null,
      loading: false,
      options: {},
      sortBy: ['employee_code'],
      sortDesc: [false],
      search: '',
      tempEmployeeList: [],
      totalTempEmployeeList: 0,

      accessAuthorityLoading: false,
      accessAuthoritiesSelected: [],

      confirmDialogFaceDataChange: false,
      confirmDialogFaceDataChangeLoading: false,
      confirmDialogFaceDataChangeData: {},
      confirmDialogFingerDataChange: false,
      confirmDialogFingerDataChangeLoading: false,
      confirmDialogFingerDataChangeData: {},
      confirmDialogFaceDelete: false,
      confirmDialogFaceDeleteLoading: false,
      confirmDialogFaceDeleteData: {},
      confirmDialogFingerDelete: false,
      confirmDialogFingerDeleteLoading: false,
      confirmDialogFingerDeleteData: {},

      faceFileAdd: null,
      faceFileAddPreview: null,

      faceFileEdit: null,
      faceFileEditPreview: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    company() {
      return this.$store.state.company.company
    },
    employeeLevels() {
      return this.$store.state.employeeLevel.employeeLevels
    },
    genders() {
      return this.$store.state.gender.genders
    },
    prefixs() {
      return this.$store.state.prefix.prefixs
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
    positions() {
      return this.$store.state.position.positions
    },
    employeeTypes() {
      return this.$store.state.employeeType.employeeTypes
    },
    shifts() {
      return this.$store.state.shift.shifts
    },
    biometrics() {
      return this.$store.state.employee.biometrics
    },
    employeeBiometric() {
      return this.$store.state.employee.employeeBiometric
    },
    identifyModes() {
      return this.$store.state.hardware.identifyModes
    },
    accessAuthorities() {
      return this.$store.state.accessAuthority.accessAuthorities
    },
    isDialogFaceFormAddDataChange() {
      if (this.faceFileAdd) {
        return true
      } else {
        return false
      }
    },
    isDialogFaceFormEditDataChange() {
      if (this.faceFileEdit) {
        return true
      } else {
        return false
      }
    },
    isDialogFingerFormAddDataChange() {
      if (this.selectBiometricPropertyCode || this.fileTpl || this.fileDat) {
        return true
      } else {
        return false
      }
    },
    isDialogFingerFormEditDataChange() {
      if (
        this.selectFileType !== this.selectFileTypeInit ||
        this.fileTpl ||
        this.fileDat
      ) {
        return true
      } else {
        return false
      }
    },
    filterBiometricProperty() {
      const employeeBio = this.employeeBiometric.flatMap((empBio) =>
        empBio?.biometric_property.map(
          (biometricProp) => biometricProp.biometric_property_code
        )
      )

      if (!employeeBio.length) {
        return this.biometric.biometric_property
      }

      return this.biometric.biometric_property.filter(
        (biometricProp) =>
          !employeeBio.includes(biometricProp.biometric_property_code)
      )
    },
  },
  methods: {
    ...mapActions({
      fetchTempEmployeeList: 'employee/fetchTempEmployeeList',
      deleteTempEmployee: 'employee/deleteTempEmployee',
      addEmployee: 'employee/addEmployee',
      addCard: 'card/addCard',
      fetchCardTypes: 'card/fetchCardTypes',
      verifyCardSerialNumber: 'card/verifyCardSerialNumber',
      fetchAccessAuthorities: 'accessAuthority/fetchAccessAuthorities',
      addEmployeeToAuthorities: 'employee/addEmployeeToAuthorities',
    }),
    async onFaceFileAddChange(file) {
      if (file && this.$refs.imgFaceFileAddInput.validate()) {
        this.faceFileAdd = file
        const result = await this.getBase64(file)
        this.faceFileAddPreview = result.split(',').pop()
      }
    },
    async onFaceFileEditChange(file) {
      if (file && this.$refs.imgFaceFileEditInput.validate()) {
        this.faceFileEdit = file
        const result = await this.getBase64(file)
        this.faceFileEditPreview = result.split(',').pop()
      }
    },
    onFaceFileAddClear() {
      this.faceFileAdd = null
      this.faceFileAddPreview = null
    },
    onFaceFileEditClear() {
      this.faceFileEdit = null
      this.faceFileEditPreview = null
    },
    async handleEmployeeFaceFormAdd() {
      if (this.$refs.imgFaceFileAddInput.validate()) {
        try {
          let file_base64 = null
          let file_ext = null
          let file_size_byte = null
          if (this.faceFileAdd) {
            file_base64 = await this.getBase64(this.faceFileAdd)
            file_base64 = file_base64.split(',').pop()
            file_ext = this.faceFileAdd.type.split('/').pop()
            file_size_byte = this.faceFileAdd.size
          }

          let biometricProperty = []

          biometricProperty = this.biometric.biometric_property
            .filter((item) => item.biometric_property_code === 'face')
            .map((item) => ({
              ...item,
              employee_biometric: {
                biometric_property_code: item.biometric_property_code,
                file_base64,
                file_ext: `.${file_ext}`,
                file_size_byte,
              },
            }))

          const employeeBio = this.employeeBiometric.find(
            (e) => e.biometric_code === this.biometric.biometric_code
          )

          const faceData = {
            biometric_code: this.biometric.biometric_code,
            biometric_property: employeeBio
              ? [...employeeBio.biometric_property, ...biometricProperty]
              : [...biometricProperty],
            title_th: this.biometric.title_th,
            title_en: this.biometric.title_en,
          }

          this.$refs.imgFaceFileAddInput.reset()
          this.faceFileAdd = null
          this.faceFileAddPreview = null

          const employeeBiometric = this.$store.state.employee.employeeBiometric
          const index = employeeBiometric.findIndex(
            (eb) => eb.biometric_code === faceData.biometric_code
          )
          if (index !== -1) {
            employeeBiometric.splice(index, 1)
          }

          this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [
            ...employeeBiometric,
            { ...faceData },
          ])

          this.dialogFaceFormAdd = false
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async handleEmployeeFaceFormEdit() {
      if (this.$refs.imgFaceFileEditInput.validate()) {
        try {
          let file_base64 = null
          let file_ext = null
          let file_size_byte = null
          if (this.faceFileEdit) {
            file_base64 = await this.getBase64(this.faceFileEdit)
            file_base64 = file_base64.split(',').pop()
            file_ext = this.faceFileEdit.type.split('/').pop()
            file_size_byte = this.faceFileEdit.size
          }

          let biometricProperty = []

          biometricProperty = this.biometric.biometric_property
            .filter(
              (item) =>
                item.biometric_property_code ===
                this.biometricSelected.biometric_property_code
            )
            .map((item) => ({
              ...item,
              employee_biometric: {
                biometric_property_code: item.biometric_property_code,
                file_base64,
                file_ext: `.${file_ext}`,
                file_size_byte,
              },
            }))

          const employeeBio = this.employeeBiometric.find(
            (e) => e.biometric_code === this.biometric.biometric_code
          )

          if (employeeBio) {
            const index = employeeBio.biometric_property.findIndex(
              (eb) =>
                eb.biometric_property_code === this.biometric.biometric_code
            )

            if (index !== -1) {
              employeeBio.biometric_property.splice(index, 1)
            }
          }

          const faceData = {
            biometric_code: this.biometric.biometric_code,
            biometric_property: employeeBio
              ? [...employeeBio.biometric_property, ...biometricProperty]
              : [...biometricProperty],
            title_th: this.biometric.title_th,
            title_en: this.biometric.title_en,
          }

          this.$refs.imgFaceFileEditInput.reset()
          this.faceFileEdit = null
          this.faceFileEditPreview = null

          const employeeBiometric = this.$store.state.employee.employeeBiometric
          const index = employeeBiometric.findIndex(
            (eb) => eb.biometric_code === faceData.biometric_code
          )

          if (index !== -1) {
            employeeBiometric.splice(index, 1)
          }

          this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [
            ...employeeBiometric,
            { ...faceData },
          ])

          this.dialogFaceFormEdit = false
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async handleEmployeeFingerFormAdd() {
      const fileKey =
        this.selectFileType === '.dat'
          ? 'fingerFileInputDat'
          : 'fingerFileInputTpl'

      if (this.$refs[fileKey].validate()) {
        try {
          let file_base64 = null
          let file_ext = null
          let file_size_byte = null
          if (this.fileTpl) {
            file_base64 = await this.getBase64(this.fileTpl)
            file_base64 = file_base64.split(',').pop()
            file_ext = this.fileTpl.name.split('.').pop()
            file_size_byte = this.fileTpl.size
          }
          if (this.fileDat) {
            file_base64 = await this.getBase64(this.fileDat)
            file_base64 = file_base64.split(',').pop()
            file_ext = this.fileDat.name.split('.').pop()
            file_size_byte = this.fileDat.size
          }

          let biometricProperty = []

          if (this.selectBiometricPropertyCode) {
            biometricProperty = this.biometric.biometric_property
              .filter(
                (item) =>
                  item.biometric_property_code ===
                  this.selectBiometricPropertyCode
              )
              .map((item) => ({
                ...item,
                employee_biometric: {
                  biometric_property_code: item.biometric_property_code,
                  file_base64_legacy: this.fileDat ? file_base64 : undefined,
                  file_base64: this.fileDat ? undefined : file_base64,
                  file_ext: `.${file_ext}`,
                  file_size_byte,
                },
              }))
          } else {
            biometricProperty = this.biometric.biometric_property.map(
              (item) => ({
                ...item,
                employee_biometric: {
                  biometric_property_code: item.biometric_property_code,
                  file_base64_legacy: this.fileDat ? file_base64 : undefined,
                  file_base64: this.fileDat ? undefined : file_base64,
                  file_ext: `.${file_ext}`,
                  file_size_byte,
                },
              })
            )
          }

          const employeeBio = this.employeeBiometric.find(
            (e) => e.biometric_code === this.biometric.biometric_code
          )

          const fingerData = {
            biometric_code: this.biometric.biometric_code,
            biometric_property: employeeBio
              ? this.selectBiometricPropertyCode
                ? [...employeeBio.biometric_property, ...biometricProperty]
                : [...biometricProperty]
              : [...biometricProperty],
            title_th: this.biometric.title_th,
            title_en: this.biometric.title_en,
          }

          this.$refs?.fingerFileInputDat?.reset()
          this.$refs?.fingerFileInputTpl?.reset()
          this.fileDat = null
          this.fileTpl = null

          const employeeBiometric = this.$store.state.employee.employeeBiometric
          const index = employeeBiometric.findIndex(
            (eb) => eb.biometric_code === fingerData.biometric_code
          )
          if (index !== -1) {
            employeeBiometric.splice(index, 1)
          }

          this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [
            ...employeeBiometric,
            { ...fingerData },
          ])

          this.dialogFingerFormAdd = false
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async handleEmployeeFingerFormEdit() {
      const fileKey =
        this.selectFileType === '.dat'
          ? 'fingerFileInputDat'
          : 'fingerFileInputTpl'

      if (this.$refs[fileKey].validate()) {
        try {
          let file_base64 = null
          let file_ext = null
          let file_size_byte = null
          if (this.fileTpl) {
            file_base64 = await this.getBase64(this.fileTpl)
            file_base64 = file_base64.split(',').pop()
            file_ext = this.fileTpl.name.split('.').pop()
            file_size_byte = this.fileTpl.size
          }
          if (this.fileDat) {
            file_base64 = await this.getBase64(this.fileDat)
            file_base64 = file_base64.split(',').pop()
            file_ext = this.fileDat.name.split('.').pop()
            file_size_byte = this.fileDat.size
          }

          let biometricProperty = []

          if (this.selectFileType === '.dat') {
            biometricProperty = this.biometric.biometric_property.map(
              (item) => ({
                ...item,
                employee_biometric: {
                  biometric_property_code: item.biometric_property_code,
                  file_base64_legacy: this.fileDat ? file_base64 : undefined,
                  file_base64: this.fileDat ? undefined : file_base64,
                  file_ext: `.${file_ext}`,
                  file_size_byte,
                },
              })
            )
          } else {
            biometricProperty = this.biometric.biometric_property
              .filter(
                (item) =>
                  item.biometric_property_code ===
                  this.biometricSelected.biometric_property_code
              )
              .map((item) => ({
                ...item,
                employee_biometric: {
                  biometric_property_code: item.biometric_property_code,
                  file_base64_legacy: this.fileDat ? file_base64 : undefined,
                  file_base64: this.fileDat ? undefined : file_base64,
                  file_ext: `.${file_ext}`,
                  file_size_byte,
                },
              }))
          }

          const employeeBio = this.employeeBiometric.find(
            (e) => e.biometric_code === this.biometric.biometric_code
          )

          if (employeeBio) {
            if (this.selectFileType === '.tpl') {
              const index = employeeBio.biometric_property.findIndex(
                (eb) =>
                  eb.biometric_property_code === this.biometric.biometric_code
              )

              if (index !== -1) {
                employeeBio.biometric_property.splice(index, 1)
              }
            } else {
              employeeBio.biometric_property = []
            }
          }

          const fingerData = {
            biometric_code: this.biometric.biometric_code,
            biometric_property: employeeBio
              ? [...employeeBio.biometric_property, ...biometricProperty]
              : [...biometricProperty],
            title_th: this.biometric.title_th,
            title_en: this.biometric.title_en,
          }

          this.$refs?.fingerFileInputDat?.reset()
          this.$refs?.fingerFileInputTpl?.reset()
          this.fileDat = null
          this.fileTpl = null

          const employeeBiometric = this.$store.state.employee.employeeBiometric
          const index = employeeBiometric.findIndex(
            (eb) => eb.biometric_code === fingerData.biometric_code
          )

          if (index !== -1) {
            employeeBiometric.splice(index, 1)
          }

          this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [
            ...employeeBiometric,
            { ...fingerData },
          ])

          this.dialogFingerFormEdit = false
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    onCloseDialogFaceFormAdd() {
      if (this.isDialogFaceFormAddDataChange) {
        this.confirmDialogFaceDataChange = true
        this.confirmDialogFaceDataChangeData = {
          title: 'ยืนยันการยกเลิก',
          text: 'มีการเปลี่ยนแปลงข้อมูลใบหน้า คุณต้องการยกเลิกหรือไม่',
        }
        return
      }

      this.$refs.imgFaceFileAddInput.reset()
      this.faceFileAdd = null
      this.faceFileAddPreview = null

      this.dialogFaceFormAdd = false
    },
    onCloseDialogFaceFormEdit() {
      if (this.isDialogFaceFormEditDataChange) {
        this.confirmDialogFaceDataChange = true
        this.confirmDialogFaceDataChangeData = {
          title: 'ยืนยันการยกเลิก',
          text: 'มีการเปลี่ยนแปลงข้อมูลใบหน้า คุณต้องการยกเลิกหรือไม่',
        }
        return
      }

      this.$refs.imgFaceFileEditInput.reset()
      this.faceFileEdit = null
      this.faceFileEditPreview = null

      this.dialogFaceFormEdit = false
    },
    onCloseDialogFingerFormAdd() {
      if (this.isDialogFingerFormAddDataChange) {
        this.confirmDialogFingerDataChange = true
        this.confirmDialogFingerDataChangeData = {
          title: 'ยืนยันการยกเลิก',
          text: 'มีการเปลี่ยนแปลงข้อมูลลายนิ้วมือ คุณต้องการยกเลิกหรือไม่',
        }
        return
      }

      this.$refs?.fingerFileInputDat?.reset()
      this.$refs?.fingerFileInputTpl?.reset()
      this.fileDat = null
      this.fileTpl = null

      this.dialogFingerFormAdd = false
    },
    onCloseDialogFingerFormEdit() {
      if (this.isDialogFingerFormEditDataChange) {
        this.confirmDialogFingerDataChange = true
        this.confirmDialogFingerDataChangeData = {
          title: 'ยืนยันการยกเลิก',
          text: 'มีการเปลี่ยนแปลงข้อมูลลายนิ้วมือ คุณต้องการยกเลิกหรือไม่',
        }
        return
      }

      this.$refs?.fingerFileInputDat?.reset()
      this.$refs?.fingerFileInputTpl?.reset()
      this.fileDat = null
      this.fileTpl = null

      this.dialogFingerFormEdit = false
    },
    cancelConfirmDialogFaceDataChange() {
      this.confirmDialogFaceDataChange = false
    },
    cancelConfirmDialogFingerDataChange() {
      this.confirmDialogFingerDataChange = false
    },
    submitConfirmDialogFaceDataChange() {
      this.confirmDialogFaceDataChange = false

      this.$refs?.imgFaceFileAddInput?.reset()
      this.$refs?.imgFaceFileEditInput?.reset()
      this.faceFileAdd = null
      this.faceFileEdit = null
      this.faceFileAddPreview = null
      this.faceFileEditPreview = null

      this.dialogFaceFormAdd = false
      this.dialogFaceFormEdit = false
    },
    submitConfirmDialogFingerDataChange() {
      this.confirmDialogFingerDataChange = false

      this.$refs?.fingerFileInputDat?.reset()
      this.$refs?.fingerFileInputTpl?.reset()
      this.fileDat = null
      this.fileTpl = null

      this.dialogFingerFormAdd = false
      this.dialogFingerFormEdit = false
    },
    onCancelDialogFaceFormAdd() {
      this.$refs.imgFaceFileAddInput.reset()
      this.faceFileAdd = null
      this.faceFileAddPreview = null

      this.dialogFaceFormAdd = false
    },
    onCancelDialogFaceFormEdit() {
      this.$refs.imgFaceFileEditInput.reset()
      this.faceFileEdit = null
      this.faceFileEditPreview = null

      this.dialogFaceFormEdit = false
    },
    onCancelDialogFingerFormAdd() {
      this.$refs?.fingerFileInputDat?.reset()
      this.$refs?.fingerFileInputTpl?.reset()
      this.fileDat = null
      this.fileTpl = null

      this.dialogFingerFormAdd = false
    },
    onCancelDialogFingerFormEdit() {
      this.$refs?.fingerFileInputDat?.reset()
      this.$refs?.fingerFileInputTpl?.reset()
      this.fileDat = null
      this.fileTpl = null

      this.dialogFingerFormEdit = false
    },
    handleDeleteEmployeeFace() {
      this.confirmDialogFaceDelete = true
      this.confirmDialogFaceDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบ',
        value: `${this.biometricSelected.title_th}`,
        item: this.biometricSelected,
      }
    },
    cancelConfirmDialogFaceDelete() {
      this.confirmDialogFaceDelete = false
    },
    submitConfirmDialogFaceDelete(biometric) {
      const employeeBio = this.employeeBiometric.find(
        (e) => e.biometric_code === this.biometric.biometric_code
      )

      if (employeeBio) {
        employeeBio.biometric_property = employeeBio.biometric_property.filter(
          (biometricProp) =>
            biometricProp.biometric_property_code !==
            biometric.biometric_property_code
        )
      }

      this.confirmDialogFaceDelete = false

      this.$refs.imgFaceFileEditInput.reset()
      this.faceFileEdit = null
      this.faceFileEditPreview = null

      this.dialogFaceFormEdit = false
    },
    handleDeleteEmployeeFinger() {
      this.confirmDialogFingerDelete = true
      this.confirmDialogFingerDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบ',
        value: `${this.biometricSelected.title_th}`,
        item: this.biometricSelected,
      }
    },
    cancelConfirmDialogFingerDelete() {
      this.confirmDialogFingerDelete = false
    },
    submitConfirmDialogFingerDelete(biometric) {
      const employeeBio = this.employeeBiometric.find(
        (e) => e.biometric_code === this.biometric.biometric_code
      )

      if (employeeBio) {
        employeeBio.biometric_property = employeeBio.biometric_property.filter(
          (biometricProp) =>
            biometricProp.biometric_property_code !==
            biometric.biometric_property_code
        )
      }

      this.confirmDialogFingerDelete = false

      this.$refs?.fingerFileInputDat?.reset()
      this.$refs?.fingerFileInputTpl?.reset()
      this.fileDat = null
      this.fileTpl = null

      this.dialogFingerFormEdit = false
    },
    handleClickEditFace(selectedFace) {
      this.biometricSelected = { ...selectedFace }
      this.dialogFaceFormEdit = true
    },
    handleClickEditFinger(selectedFinger) {
      this.biometricSelected = { ...selectedFinger }
      this.dialogFingerFormEdit = true
    },
    async onFileChangeTpl(fileTpl) {
      if (fileTpl && this.$refs.fingerFileInputTpl.validate()) {
        this.fileTpl = fileTpl
      }
    },
    async onFileChangeDat(fileDat) {
      if (fileDat && this.$refs.fingerFileInputDat.validate()) {
        this.fileDat = fileDat
      }
    },
    onFileClearTpl() {
      this.fileTpl = null
    },
    onFileClearDat() {
      this.fileDat = null
    },
    handleOnClickBiometric(biometric) {
      if (biometric.biometric_code === 'face') {
        this.dialogFaceFormList = true
        this.biometric = { ...biometric }
        return
      }

      this.dialogFingerFormList = true
      this.biometric = { ...biometric }
    },
    handleSerialChange() {
      this.serialValid = true
      this.serialMessageError = ''
    },
    async onFileChange(file) {
      if (file) {
        this.fileImage = file
        const result = await this.getBase64(file)
        this.uploadFilePreview = result.split(',').pop()
      }
    },
    onFileClear() {
      this.fileImage = null
      this.uploadFilePreview = null
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    handleDeleteEmployeeDevice(item) {
      this.confirmDelete = true
      this.confirmDeleteData = item
    },
    cancelConfirmDelete() {
      this.confirmDelete = false
      this.confirmDeleteData = {}
    },
    async submitConfirmDelete() {
      try {
        this.confirmDeleteLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          employee_temporary_uuid:
            this.confirmDeleteData.employee_temporary_uuid,
        }

        await this.deleteTempEmployee(payload)

        this.confirmDeleteLoading = false
        this.confirmDelete = false
        this.confirmDeleteData = {}

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        this.getTempEmployeeList()
      } catch (error) {
        this.confirmDeleteLoading = false
        this.confirmDeleteData = {}

        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    onCancel() {
      this.$refs.form.resetValidation()

      this.dialogEmployeeDeviceForm = false

      this.employee = {
        biometric: [],
        card: {},
      }
      this.employeeInit = {
        biometric: [],
        card: {},
      }
      this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [])
    },
    async onSubmit() {
      if (
        !this.employee.employee_code ||
        !this.employee.firstname_th ||
        !this.employee.lastname_th ||
        !this.employee.organization_uuid ||
        !this.employee.position_uuid ||
        !this.employee.employee_type_uuid ||
        !this.employee.shift_uuid
      ) {
        this.tabs = 0
        this.$refs?.form.validate()

        return
      }

      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          // verify card serial number
          if (this.employee.card.sn) {
            const cardSerialNumber = this.employee.card.sn.trim()
            const verifyPayload = {
              body: {
                company_uuid,
                serial_number: cardSerialNumber,
              },
            }
            const verifyResult = await this.verifyCardSerialNumber(
              verifyPayload
            )
            if (!_.isEmpty(verifyResult.employee)) {
              this.$store.state.loading = false

              this.serialValid = false
              this.serialMessageError =
                'หมายเลขบัตรนี้มีผู้ใช้แล้ว กรุณาเปลี่ยนหมายเลขบัตร'

              this.tabs = 1

              this.$nextTick(() => {
                this.$refs.serialInput.focus()
              })
              return
            }
          }

          let file_base64 = null
          let file_ext = null

          if (this.fileImage) {
            const result = await this.getBase64(this.fileImage)
            file_base64 = result.split(',').pop()
            file_ext = `.${this.fileImage.type.split('/').pop()}`
          }

          const newEmployee = {
            ...this.employee,
            photo_identifier_extension: file_ext ? file_ext : null,
            photo_identifier: file_base64 ? file_base64 : null,
            organization_uuid: this.employee.organization_uuid,
            position_uuid: this.employee.position_uuid,
            employee_level_uuid: this.employee.employee_level_uuid || null,
            employee_type_uuid: this.employee.employee_type_uuid,
            shift_uuid: this.employee.shift_uuid,
            employee_code: this.employee.employee_code,
            employee_reference_code:
              this.employee.employee_reference_code || null,
            ms_entraid_email: this.employee.ms_entraid_email || null,
            pin_code: this.employee.pin_code || null,
            firstname_th: this.employee.firstname_th,
            lastname_th: this.employee.lastname_th,
            firstname_en: this.employee.firstname_en
              ? this.employee.firstname_en
              : null,
            lastname_en: this.employee.lastname_en
              ? this.employee.lastname_en
              : null,
            gender_id: this.employee.gender_id || null,
            company_prefix_uuid: this.employee.company_prefix_uuid || null,
            phone_no: this.employee.phone_no ? this.employee.phone_no : null,
            email: this.employee.email ? this.employee.email : null,
            birthday: this.employee.birthday
              ? moment(this.employee.birthday).format('YYYY-MM-DD')
              : null,
            time_attendance_start_time: this.employee.time_attendance_start_time
              ? moment(this.employee.time_attendance_start_time).format()
              : null,
            time_attendance_end_time: this.employee.time_attendance_end_time
              ? moment(this.employee.time_attendance_end_time).format()
              : null,
            role_uuid: this.$store.state.role.roles[0].role_uuid,
            identify_mode:
              this.employee.identify_mode || this.employee.identify_mode === 0
                ? this.employee.identify_mode
                : 8,
            is_active: this.employee.is_active,
          }

          const { employee_uuid } = await this.addEmployee({
            company_uuid,
            employee: newEmployee,
          })

          const cardApiPostList = []
          if (this.employee.card.sn) {
            await this.fetchCardTypes({
              company_uuid,
              params: {
                dpc: 'employee-to-list-card-type',
              },
            })

            const cardTypes = this.$store.state.card.cardTypes
            const defaultEmployeeCard = cardTypes.find(
              (cardType) => cardType.is_default_for_employee_card
            )

            cardApiPostList.push(
              this.addCard({
                company_uuid,
                body: {
                  employee_uuid,
                  card_type_uuid: defaultEmployeeCard?.card_type_uuid || null,
                  card_material_code: null,
                  card_number: null,
                  card_identifiers: [
                    {
                      card_identifier_type_code:
                        defaultEmployeeCard?.default_card_identifier_type_code ||
                        null,
                      sn: {
                        base_10: null,
                        base_16: null,
                        string: this.employee.card.sn,
                      },
                      default_display_encoding: {
                        sn_base_10: false,
                        sn_base_16: false,
                        sn_string: true,
                      },
                      is_base_10_16_locked: true,
                      issue_datetime: null,
                      expire_datetime: null,
                      freeze_datetime: null,
                      discard_datetime: null,
                    },
                  ],
                },
              })
            )
          }

          const biometricApiPutList = []
          const faceBiometricInit = this.employee.biometric.find(
            (e) => e.biometric_code === 'face'
          )
          const faceBiometric =
            this.$store.state.employee.employeeBiometric.find(
              (e) => e.biometric_code === 'face'
            )
          if (
            JSON.stringify(faceBiometricInit) !== JSON.stringify(faceBiometric)
          ) {
            faceBiometric.biometric_property.forEach((face) => {
              biometricApiPutList.push(
                this.$store.dispatch('employee/addEmployeeBiometric', {
                  company_uuid,
                  employee_uuid,
                  biometric_property_code: face.biometric_property_code,
                  body: {
                    ...face.employee_biometric,
                  },
                })
              )
            })
          }

          const fingerInit = this.employee.biometric.find(
            (e) => e.biometric_code === 'fingerprint_secugen'
          )
          const fingerInitSecugen1 = fingerInit?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_1'
          )
          const fingerInitSecugen2 = fingerInit?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_2'
          )
          const finger = this.$store.state.employee.employeeBiometric.find(
            (e) => e.biometric_code === 'fingerprint_secugen'
          )
          const fingerSecugen1 = finger?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_1'
          )
          const fingerSecugen2 = finger?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_2'
          )
          if (JSON.stringify(fingerInit) !== JSON.stringify(finger)) {
            if (fingerSecugen1 && fingerSecugen1 !== fingerInitSecugen1) {
              biometricApiPutList.push(
                this.$store.dispatch('employee/addEmployeeBiometric', {
                  company_uuid,
                  employee_uuid,
                  biometric_property_code:
                    fingerSecugen1.biometric_property_code,
                  body: {
                    ...fingerSecugen1.employee_biometric,
                  },
                })
              )
            }
            if (fingerSecugen2 && fingerSecugen2 !== fingerInitSecugen2) {
              biometricApiPutList.push(
                this.$store.dispatch('employee/addEmployeeBiometric', {
                  company_uuid,
                  employee_uuid,
                  biometric_property_code:
                    fingerSecugen2.biometric_property_code,
                  body: {
                    ...fingerSecugen2.employee_biometric,
                  },
                })
              )
            }
          }

          const accessAuthoritiesApiPostList = []
          if (this.accessAuthoritiesSelected.length > 0) {
            accessAuthoritiesApiPostList.push(
              this.addEmployeeToAuthorities({
                company_uuid,
                body: {
                  employee_uuid,
                  authority_uuids: [...this.accessAuthoritiesSelected],
                },
              })
            )
          }

          await Promise.all([
            ...cardApiPostList,
            ...biometricApiPutList,
            ...accessAuthoritiesApiPostList,
          ])

          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.dialogEmployeeDeviceForm = false

          this.employee = {
            biometric: [],
            card: {},
          }
          this.employeeInit = {
            biometric: [],
            card: {},
          }
          this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [])

          this.$refs.form.resetValidation()
          this.fileImage = null
          this.uploadFilePreview = null
          this.serialValid = true
          this.serialMessageError = ''

          this.getTempEmployeeList()
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this.employee[field] = value.trim()
      }
    },
    async handleAddEmployeeDevice(item) {
      this.employee = {
        ...item,
        card: item.card
          ? {
              card_uuid: item?.card[0]?.card_uuid,
              sn: item?.card_serial_number,
            }
          : {
              sn: item?.card_serial_number,
            },
        is_active: true,
      }

      const employeeBiometric =
        item.biometric?.map((bio) => ({
          ...bio,
        })) || []

      this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', employeeBiometric)

      this.dialogEmployeeDeviceForm = true

      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'employee-temporary-to-list-authority',
          },
        }

        this.accessAuthorityLoading = true

        await this.fetchAccessAuthorities(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.accessAuthorityLoading = false
      }
    },
    handleCloseDialog() {
      this.$emit('onCloseDialog')
    },
    handleSearch() {
      this.loading = true
      this.getTempEmployeeListBySearch()
    },
    getTempEmployeeListBySearch: _.debounce(function () {
      this.options.page = 1
      this.getTempEmployeeList()
    }, 1000),
    async getTempEmployeeList() {
      try {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        const sortParams = sortBy
          .map((field, i) => `${field}:${sortDesc[i] ? 'desc' : 'asc'}`)
          .join(',')

        if (this.cancelSource) {
          this.cancelSource.abort()
        }

        const controller = new AbortController()
        this.cancelSource = controller

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: '',
            search: this.search || undefined,
            sort: sortParams || undefined,
            limit: itemsPerPage,
            offset: (page - 1) * itemsPerPage,
          },
          signal: controller.signal,
        }

        this.loading = true

        const { data, total } = await this.fetchTempEmployeeList(payload)
        this.tempEmployeeList = data
        this.totalTempEmployeeList = total

        this.loading = false
      } catch (error) {
        if (error.name === 'CanceledError') {
          // Request was cancelled, do nothing
          return
        }

        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
  },
  beforeDestroy() {
    if (this.cancelSource) {
      this.cancelSource.abort()
    }
  },
}
</script>
